import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import type { BaseButtonStyle } from "components/designV2/buttons/baseButton";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { Footer } from "./timeReportDetailsPanel.styled";

interface ActionItemBase {
  readonly label: string;
  readonly onClick: () => void;
  readonly disabled: boolean;
  readonly disabledReason?: string;
}

export type ActionItem = ActionItemBase &
  (
    | {
        readonly kind: "approve";
        readonly isLoading: boolean;
      }
    | {
        readonly kind: "reject";
        readonly isLoading: boolean;
      }
    | {
        readonly kind: "retract";
        readonly isLoading: boolean;
      }
    | {
        readonly kind: "reset";
        readonly isLoading: boolean;
      }
    | {
        readonly kind: "absence";
      }
  );

interface ActionFooterProps {
  readonly groupAriaLabel: string;
  readonly actions: ActionItem[];
  readonly denyButtonStyles: Partial<BaseButtonStyle>;
  readonly approveButtonStyles: Partial<BaseButtonStyle>;
}

export const ActionFooter = (props: ActionFooterProps): JSX.Element => {
  const renderAction = (action: ActionItem): JSX.Element => {
    let button: JSX.Element;

    switch (action.kind) {
      case "retract":
        button = (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
        break;
      case "absence":
        button = (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            disabled={action.disabled}
            onClick={action.onClick}
          />
        );
        break;
      case "reset":
        button = (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
        break;
      case "reject":
        button = (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            iconName="v2/cross"
            styleOverrides={props.denyButtonStyles}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
        break;
      case "approve":
        button = (
          <PrimaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            styleOverrides={props.approveButtonStyles}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
        break;
      default: {
        const _exhaustive: never = action;
        return _exhaustive;
      }
    }

    return action.disabledReason ? (
      <TooltipHover key={action.kind} text={action.disabledReason} fullWidth>
        {button}
      </TooltipHover>
    ) : (
      button
    );
  };

  return (
    <Footer role="group" aria-label={props.groupAriaLabel}>
      {props.actions.map((action) => renderAction(action))}
    </Footer>
  );
};
